import React from "react";
import "./index.scss";

export default function ComingSoon({ icon, title }) {
  return (
    <div className="page-content w-100">
      <div className="white-space d-flex justify-content-center">
        <div className="white-c">
          {/* <div className="icon">{icon}</div> */}
          <div className="soon align-self-end">Coming Soon</div>
          <span className="soon-detail align-self-end">
            For additional details contact: support@easyshul.com
          </span>
        </div>
      </div>
      {/* <div className="">COMING SOON</div>
      <div className="soon-p">
        This page is under construction we will serve it to you shortly
      </div> */}
    </div>
  );
}
